/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_Name_HintInputs */



/**
* | output |
* | --- |
* | "Give this connection a name." |
*
* @param {My_Integrations_Wizard_Name_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_name_hint = /** @type {((inputs?: My_Integrations_Wizard_Name_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_Name_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie dieser Verbindung einen Namen.")
	return /** @type {LocalizedString} */ ("Give this connection a name.")
});